import React, { Component } from 'react';

import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';
import { Creators as InterviewsActions } from 'store/ducks/interviews';

import { Page, Panel, Loading } from 'components';

class Dashboard extends Component {
  componentDidMount() {
    const { getInterviewsStatistcsRequest } = this.props;

    getInterviewsStatistcsRequest();
  }

  render() {
    const { statistics } = this.props;

    return (
      <Page>
        <Page.Title id="page-title-tour">Dashboard</Page.Title>

        {statistics.loading ? (
          <Loading type="page" size="x-large" />
        ) : (
          <div className="row">
            <div className="col-4">
              <Panel>
                <Panel.Title>Total</Panel.Title>
                {`${statistics.data.total} entrevistas`}
              </Panel>
            </div>

            <div className="col-4">
              <Panel>
                <Panel.Title>Finalizadas</Panel.Title>
                {`${statistics.data.finalized} entrevistas finalizadas`}
              </Panel>
            </div>

            <div className="col-4">
              <Panel>
                <Panel.Title>Não Finalizadas</Panel.Title>
                {`${statistics.data.not_finalized} entrevistas não finalizadas`}
              </Panel>
            </div>
          </div>
        )}
      </Page>
    );
  }
}

const mapState = state => ({
  statistics: state.interviews.statistics,
});

const mapActions = dispatch => bindActionCreators(InterviewsActions, dispatch);

export default connect(
  mapState,
  mapActions,
)(Dashboard);



// WEBPACK FOOTER //
// ./src/pages/Admin/Dashboard/index.js